import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["formGuid", "onDismissOtherPagesWarning", "onClose", "onClone", "onFormChange"];
import { connect } from 'react-redux';
import * as formsSelectors from 'ContentData/selectors/forms';
import * as FormActions from 'ContentData/actions/Forms';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PagesList from './PagesList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.form.withInlineEditing.parentPages.modal.${key}`;
const PagesModal = ({
  pages,
  onCloneForm,
  onClose
}) => /*#__PURE__*/_jsxs(Modal, {
  "data-selenium": "form-used-on-pages-modal",
  children: [/*#__PURE__*/_jsxs(DialogHeader, {
    children: [/*#__PURE__*/_jsx(DialogCloseButton, {
      onClick: onClose
    }), /*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('header')
      })
    })]
  }), /*#__PURE__*/_jsxs(DialogBody, {
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('body')
      })
    }), /*#__PURE__*/_jsx(PagesList, {
      pages: pages
    })]
  }), /*#__PURE__*/_jsxs(DialogFooter, {
    children: [/*#__PURE__*/_jsx(Button, {
      use: "primary",
      onClick: onClose,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('confirm')
      })
    }), /*#__PURE__*/_jsx(Button, {
      onClick: onCloneForm,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('copy')
      })
    })]
  })]
});
const mapStateToProps = (state, props) => ({
  pages: formsSelectors.getParentPages(state, props.formGuid)
});
const mapDispatchToProps = {
  onDismissOtherPagesWarning: FormActions.onDismissOtherPagesWarning,
  onClone: FormActions.cloneForm
};
const connector = connect(mapStateToProps, mapDispatchToProps);
const PagesModalContainer = props => {
  const {
      formGuid,
      onDismissOtherPagesWarning,
      onClose = () => {},
      onClone,
      onFormChange
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const handleOnClose = () => {
    onDismissOtherPagesWarning();
    onClose();
  };
  const cloneForm = () => {
    onClone(formGuid).then(({
      guid
    }) => {
      onFormChange({
        target: {
          value: guid
        }
      });
    }).catch(err => console.error(err)).finally(() => {
      handleOnClose();
    });
  };
  return /*#__PURE__*/_jsx(PagesModal, Object.assign({
    onClose: handleOnClose,
    onCloneForm: cloneForm
  }, rest));
};
export default connector(PagesModalContainer);